<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card color="red lighten-1" dark>
          <v-card-title>{{getTotalVentasHoy()}}</v-card-title>
          <v-card-text>Ventas de hoy</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="cyan lighten-1" dark>
          <v-card-title>{{getTotalVentasSemana()}}</v-card-title>
          <v-card-text>Ventas de la semana</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="green lighten-1" dark>
          <v-card-title>{{getTotalVentasMes()}}</v-card-title>
          <v-card-text>Ventas del mes</v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="purple lighten-1" dark>
          <v-card-title>{{getTotalVentasYear()}}</v-card-title>
          <v-card-text>Ventas del año</v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Ventas Anuales</v-card-title>
          <line-chart 
            :chartData="ventasComputed" 
            :options="chartOptions"
            :mainLabel="currentYear"
            :labels="chartLabels"
            class="pa-5"
          />
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn to="/reportes/inventarios" color="red" dark class="mr-2">Ver inventarios realizados</v-btn>
        <v-btn to="/reportes/movimientos-caja" color="purple" dark>Ver movimientos caja</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { DateTime } from "luxon";
import {formatDecimal} from "../services/utils"
import LineChart from "../components/Reports/LineChart";
// const { getSalesTotal } = api.services.reportesService; //from '../services/ReportesService';

export default {
  name: "Reportes",
  data(){
    return {
      ventas:[],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, values) {
                console.log(index, values);
                return '$' + formatDecimal(value);
              }
            }
          }]
        }
      },
      chartLabels: [
        "Enero",
        "Febrero", 
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
    }
  },
  components: {
    LineChart
  },
  computed: {
    ...mapGetters(['demoVentasTotal', 'demoVentasTotalByDateRange']),
    ventasComputed: {
      get: function(){ return this.ventas },
      set: function(payload){
        this.ventas = payload;
      }
    },
    currentYear(){ 
      return `${this.dateTime().year}`;
    }
  },
  methods: {
    getSalesTotal(fromDateStr, toDateStr){
      const startingDate = `${fromDateStr} 00:00:00`;
      const endDate = `${toDateStr} 23:59:00`;
      return this.demoVentasTotalByDateRange(startingDate,endDate); 
    },
    getTotalVentasHoy(){
      const startDateStr = `${this.dateTime().year}-${this.currentMonth()}-${this.currentDay()}`;
      const total = this.getSalesTotal(startDateStr, startDateStr);
      return `$${formatDecimal(total)}`;
    },
    getTotalVentasSemana(){
      const dateTime = this.dateTime();
      const startDateStr = dateTime.startOf('week').toISODate();
      const endDateStr = dateTime.endOf('week').toISODate();
      const total= this.getSalesTotal(startDateStr, endDateStr);
      return `$${formatDecimal(total)}`;
    },
    getTotalVentasMes(){
      const dateTime = this.dateTime();
      const startDateStr = `${dateTime.year}-${this.currentMonth()}-01`;
      const endDateStr = `${dateTime.year}-${this.currentMonth()}-${dateTime.daysInMonth}`
      const total = this.getSalesTotal(startDateStr, endDateStr);
      return `$${formatDecimal(total)}`;
    },
    getTotalVentasYear(){
      const startDateStr = `${this.dateTime().year}-01-01`;//"2021-01-01"
      const endDateStr = `${this.dateTime().year}-${this.currentMonth()}-${this.currentDay()}`;
      const total = this.getSalesTotal(startDateStr, endDateStr);
      return `$${formatDecimal(total)}`;
    },
    fetchSales(){ 
      const currentYear = new Date().getFullYear();
      const sales = [];
      for (let i = 1; i <= this.chartLabels.length; i++) {
        const daysInMonth = DateTime.local(currentYear, i).daysInMonth;
        const monthStr = i < 10 ? `0${i}`:`${i}`;
        const startingDateStr = `${currentYear}-${monthStr}-01`;
        const endDateStr = `${currentYear}-${monthStr}-${daysInMonth}`;
        const monthSales = this.getSalesTotal(startingDateStr, endDateStr);
        const monthSalesRounded = parseFloat(monthSales).toFixed(2);
        sales.push(monthSalesRounded);
      }
      this.ventasComputed = sales;
    },
    dateTime(){ 
      return DateTime.local();
    },
    currentDay(){ 
      const dateTime = this.dateTime();
      return dateTime.day < 10 ? `0${dateTime.day}`:dateTime.day; 
    },
    currentMonth(){ 
      const dateTime = this.dateTime();
      return dateTime.month < 10 ? `0${dateTime.month}`: dateTime.month 
    },
    
  },
  beforeMount(){
    this.fetchSales();
  }

}
</script>
